import {Helmet} from "react-helmet";
import classes from "../../../css/styles.module.scss";
import digital from "./digital.png";

const Digital = () => {
  return (
    <div>
      <Helmet><title>Backend Helpers Limited | Products | Step Forward Digital</title></Helmet>
      <main className={classes['main-content']}>
        <section id="" className={classes['project-content']}>
          <h1>Your First Step to a Smarter Business</h1>
          <p className={classes['mb-1']}>
            <strong>StepForward Digital </strong> is a refreshingly
            <strong>simple, affordable, and guided </strong>
            digital transformation solution designed specifically for small businesses.
            <strong>We are your dedicated companions on this digital journey.</strong> We walk alongside you, helping you understand exactly how technology can tackle those everyday headaches and simple problems that drain your time and energy.
          </p>
          <img src={digital} alt="Step Forward Digital" className={classes['img-tech']}/>
        </section>
        </main>
    </div>
  );
};

export default Digital;